<template id="">
  <div class="md-layout">
    <md-card class="md-layout-item md-size-100" v-if="currentCard === 1">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>settings_overscan</md-icon>
        </div>
        <h4 class="title">GPR Report: Project Overview</h4>
      </md-card-header>
      <md-card-content class="md-layout gpr-overview">
        <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100">
          <h6>ATS Number</h6>
          <h4>{{ findField("ats_number") }}</h4>
        </div>
        <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100">
          <h6>Job Name</h6>
          <h4>{{ findField("job_name") }}</h4>
        </div>
        <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100">
          <h6>Job Site Address</h6>
          <h4>{{ formatAddress("job_site") }}</h4>
        </div>
        <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100">
          <h6>Prepared for:</h6>
          <h4>
            {{ findField("prepared_for_name") }} <br />
            {{ formatAddress("prepared_for_address") }}
          </h4>
        </div>
        <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100">
          <h6>Project Manager</h6>
          <h4>
            {{ findField("project_manager_name") }} <br />
            Email: {{ findField("project_manager_email") }} <br />
            Phone: {{ findField("project_manager_phone") }}
          </h4>
        </div>
        <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100">
          <h6>Site Contact</h6>
          <h4>
            {{ findField("site_contact_name") }} <br />
            Email: {{ findField("site_contact_email") }} <br />
            Phone: {{ findField("site_contact_phone") }}
          </h4>
        </div>
        <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100">
          <h6>PO Number</h6>
          <h4>{{ findField("po_number") }}</h4>
        </div>
        <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100">
          <h6>Prepared By</h6>
          <h4>{{ findField("prepared_by") }}</h4>
        </div>
      </md-card-content>
      <md-card-actions md-alignment="right">
        <router-link :to="{ name: 'Project', params: { id: projectId } }" md-alignment="left" class="md-info">
          <md-button class="md-info">Go back to project</md-button>
        </router-link>
        <md-button class="md-info" v-on:click="nextCard(1)">Start Report</md-button>
        <md-button class="md-info" v-on:click="goSignature(5)">AUTHORIZED SIGNATURE</md-button>
      </md-card-actions>
    </md-card>
    <md-card class="md-layout-item md-size-100" v-if="currentCard == 2">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>grading</md-icon>
        </div>
        <h4 class="title">GPR Report: Activity</h4>
      </md-card-header>
      <md-card-content class="md-layout">
        <div class="md-layout-item md-size-100">
          <h4><b>Define activity completed</b></h4>
          <md-field>
            <label>Area of Work</label>
            <md-input v-model="gpr_report.area_of_work" type="text"></md-input>
          </md-field>
          <md-field>
            <label for="acitvites">Activity</label>
            <md-select v-model="gpr_report.activities" name="activities" id="activities" multiple>
              <md-option v-for="item in activities " v-bind:key="item" :value="item">
                {{ item | truncate(90) }}
              </md-option>
            </md-select>
          </md-field>
          <div class="summaries-list">
            <div class="sum-list-item" v-for="item in gpr_report.activities" v-bind:key="item">
              <p>{{ item }}</p>
              <md-icon v-on:click.native="removeItem(item, index, 'activity')">close</md-icon>
              <div class="xtra" />
            </div>
          </div>
          <md-field>
            <label>Any Observations/Findings</label>
            <md-input v-model="gpr_report.observations" type="text"></md-input>
          </md-field>
          <md-field>
            <label>GPR Technician Name</label>
            <md-input v-model="gpr_report.tech_name" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Customer Name</label>
            <md-input v-model="gpr_report.customer_name" type="text"></md-input>
          </md-field>
          <!-- <md-field class="sigbox">
            <label>Customer Signature</label>
            <md-input v-model="gpr_report.customer_signature" type="text"></md-input>
            <SigPad v-on:saveSig="saveSig2"/>
          </md-field> -->
        </div>
      </md-card-content>
      <md-card-actions md-alignment="right">
        <md-progress-spinner v-if="isLoading == true" md-mode="indeterminate" class="md-accent ats-spin"
          :md-diameter="30" :md-stroke="3"></md-progress-spinner>
        <md-button class="md-info" v-on:click="prevCard(2)">Go Back</md-button>
        <!-- <md-button
          class="md-info"
          v-on:click="submitGPR"
          :disabled="clickedOnce"
          >Submit Report</md-button
        > -->
        <md-button class="md-info" v-on:click="nextCard(2)" :disabled="clickedOnce">Add Locations</md-button>
      </md-card-actions>
    </md-card>
    <md-card class="md-layout-item md-size-100" v-if="currentCard === 3">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>settings_overscan</md-icon>
        </div>
        <h4 class="title">GPR Report: Scan Locations</h4>
      </md-card-header>
      <md-card-content>
        <div v-for="(location, index) in locations" :key="location.id">
          <div class="md-layout" v-if="currentLocation === index">
            <div class="md-layout-item md-size-100 report-header">
              <small>There are {{ locations.length }} locations for this
                project.</small>
              <h4>
                ATS {{ findField("ats_number") }} - Location {{ index + 1 }}
              </h4>
            </div>
            <div class="md-layout-item md-size-100 report-section">
              <md-field>
                <label class="upload-image">Upload Images</label>
                <md-file v-model="location.imgPlaceholder" @md-change="getFiles($event, index)" multiple
                  accept="image/*" required />
              </md-field>
              <div class="files-display" v-if="location.files && location.files.length">
                <div class="files-display-item" v-for="f in location.files" :key="f.name">
                  <div class="fdi-wrap">
                    <md-icon class="remove" v-on:click.native="removeFile(f, index)">close</md-icon>
                    <img class="fdi-img" :src="f.url" />
                    <md-button class="md-sm md-info" v-on:click="openPic(f.url)">Open Image</md-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-100 survey-section">
              <h5>SafeCore GPR Survey Location Summary</h5>
              <md-divider />
              <p class="survey-des">
                *Select GPR data collection and marking tasks performed at this
                location
              </p>
              <md-field class="mt-2 summary-field">
                <label for="summaryType">GPR Tech Marking Options:</label>
                <div class="d-flex task-lists">
                  <md-button :class="{ 'md-info': showAllTasks }" @click="showTaskAll()">Select All Tasks
                  </md-button>
                  <div class=" sum-list-item" v-for="(item, index) in summaryType" v-bind:key="index">
                    <md-button :class="{ 'md-info': item.show }" @click="showTask(index)">{{ item.category
                      }}</md-button>
                  </div>
                </div>
                <!-- <md-select
                  v-model="selectedCategory"
                  name="summaryType"
                  id="summarytype"
                  required
                >
                  <md-option
                    v-for="(item, index) in summaryType"
                    v-bind:key="index"
                    :value="item.category"
                  >
                    {{ item.category }}
                  </md-option>
                </md-select> -->
              </md-field>

              <md-field class="mt-2 summary-field">
                <!--
                <md-button
                  class="select-tasks md-info"
                  @click="clearSummary(location.id)"
                  v-if="selectedItems.length"
                  >Select Tasks Performed</md-button
                >
                -->
                <md-select ref="selectDropdown" v-model="location.summaries" name="summaries" id="summaries"
                  class="selected-tasks" placeholder="Select Tasks Performed" multiple required
                  v-if="selectedItems.length">
                  <!-- <md-option
                    v-for="(item, index) in standardItems"
                    v-bind:key="index"
                    :value="item"
                    :disabled="index === 0"
                  >
                    {{ item }}
                  </md-option> -->
                  <md-option v-for="(item, index) in selectedItems" v-bind:key="index"
                    v-bind:class="getCategoryLabel(item)" :value="item" :disabled="
                      item == 'SafeCore GPR Tech Standard Tasks' ||
                      item == 'SafeCore GPR Tech Metric Standard Tasks' ||
                      item == 'SafeCore GPR Tech Stencil Marking Options' ||
                      item ==
                        '1”-12” Depth of Targets Stencil & Tape Marking Options' ||
                      item ==
                        '25mm-300mm Depth of Targets Stencil & Tape Marking Options' ||
                      item ==
                        'SafeCore GPR Tech Tolerance Zone Marking Options' ||
                      item ==
                        'SafeCore GPR Tech Metric Tolerance Zone Marking Options' ||
                      item == 'SafeCore GPR Tech Tape Marking Options' ||
                      item == 'SafeCore GPR Tech Metric Tape Marking Options' ||
                      item ==
                        'GPR Tech Slab-on-Grade Stencil Marking Options' ||
                      item == 'SafeCore GPR Tech Optional Marking Methods'
                    ">
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
              <div class="summaries-list">
                <div class="sum-list-item" v-for="item in location.summaries" v-bind:key="item">
                  <p>{{ item }}</p>
                  <md-icon v-on:click.native="removeItem(item, index, 'summary')">close</md-icon>
                  <div class="xtra" />
                </div>
              </div>

              <md-field class="other-notes summary-field">
                <label>Other Notes: Add additional location specific information as
                  required</label>
                <md-input v-model="location.summary_notes" type="text"></md-input>
              </md-field>
              <md-field class="summary-field">
                <label>SafeCore Barcode Number</label>
                <md-input v-model="location.barcode_number" type="text"></md-input>
              </md-field>
              <md-button class="md-sm md-info" @click="showBarcodeScanner">Scan Barcode In</md-button>

              <div class="dialog-wrapper">
                <md-dialog :md-active.sync="showDialog">
                  <div class="title-top md-dialog-title">
                    <h4>Scan your barcode</h4>
                    <md-icon v-on:click.native="showBarcodeScanner">close</md-icon>
                  </div>
                  <BarcodeScannerPopover v-on:getBarcode="saveBarcodeNumber" v-bind:locationIndex="index" />
                </md-dialog>
              </div>
            </div>
            <p class="saving-notes">
              The information for this GPR survey location will save when you
              proceed to add a location, return to a previous location or save
              as final location. You may return to review and edit this location
              prior to finalizing the SafeCore GPR Survey report if required.
            </p>
            <p v-if="locationHasErrors" class='error-notes'>
              There was a problem saving this location - please try and save it again.
            </p>
            <div class="location-actions">
              <md-progress-spinner v-if="isLocationSaving == true" md-mode="indeterminate" class="md-accent ats-spin"
                :md-diameter="30" :md-stroke="3"></md-progress-spinner>
              <md-button class="md-info" @click="changeLocation(index, 'prev')" v-if="index !== 0">Previous
                Location</md-button>
              <md-button class="md-info" @click="changeLocation(index, 'next')"
                v-if="index !== locations.length - 1">Next
                Location</md-button>
              <md-button class="md-info" @click="changeLocation(index, 'add')" v-if="index == locations.length - 1"
                :disabled="location.summaries.length == 0 && filesToUpload.length == [] && location.barcode_number == ''">Save-Add
                Location</md-button>
            </div>
            <br />
            <div class="location-actions second-row">
              <md-button class="md-sm md-info" v-on:click="deleteLocation2(location.id)">Delete Location</md-button>
              <md-button class="md-info" @click="changeLocation(index, 'save')" v-if="index == locations.length - 1"
                :disabled="location.summaries.length == 0 && filesToUpload.length == [] && location.barcode_number == ''">Save
                Final Location</md-button>
            </div>
          </div>
        </div>
      </md-card-content>
      <md-card-actions md-alignment="right">
        <md-button class="md-info" v-on:click="prevCard(3)">Go Back</md-button>
        <md-button class="md-info" v-on:click="nextCard(3)" :disabled="savedLocations.length == 0 ">Review/Finalize
          Locations</md-button>
      </md-card-actions>
    </md-card>
    <md-card class="md-layout-item md-size-100" v-if="currentCard == 4">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>grading</md-icon>
        </div>
        <h4 class="title">GPR Report: Locations Review</h4>
      </md-card-header>
      <md-card-content class="md-layout">
        <div class="md-layout-item md-size-100">
          <div class="" v-for="(location, index) in savedLocations" :key="location.id">
            <h3>
              ATS {{ findField("ats_number") }} - Location {{ index + 1 }}
            </h3>
            <h6>Files</h6>
            <div class="files-display" v-if="location.files && location.files.length">
              <div class="files-display-item" v-for="f in location.files" :key="f.name">
                <div class="fdi-wrap">
                  <!-- <md-icon class="remove" v-on:click.native="removeFile(f, index)">close</md-icon> -->
                  <img class="fdi-img" :src="f.url" />
                  <md-button class="md-sm md-info" v-on:click="openPic(f.url)">Open Image</md-button>
                </div>
              </div>
            </div>
            <h6>Summary</h6>
            <p>{{ location.survey_summary }}</p>
            <h6>Other Notes</h6>
            <p>{{ location.summary_notes }}</p>
            <h6>Barcode Number</h6>
            <p>{{ location.barcode_number }}</p>
            <md-button class="md-sm md-info" v-on:click="deleteLocation(location.id)">Delete Location</md-button>
            <md-divider />
          </div>
        </div>
      </md-card-content>
      <md-card-actions md-alignment="right">
        <md-button class="md-info" v-on:click="prevCard(4)">Go Back</md-button>
        <md-button class="md-info" v-on:click="submitGPR" :disabled="clickedOnce">Submit Report</md-button>
      </md-card-actions>
    </md-card>
    <md-card class="md-layout-item md-size-100" v-if="currentCard == 5">
      <Signature v-bind:request="request" v-bind:projectId="projectId" v-on:goSign="goSignature" />
    </md-card>
  </div>
</template>
<script>
import api from "@/api";
import BarcodeScannerPopover from "@/pages/Dashboard/ProjectPages/Components/BarcodeScannerPopover.vue";
import idx from "idx";
import Signature from "@/pages/Dashboard/ProjectPages/Components/Signature.vue";

export default {
  components: {
    BarcodeScannerPopover,
    Signature
  },
  data() {
    return {
      request: {
        terms: false,
        signed_company_name: '',
        signed_user_name: '',
        customer_signature: ''
      },
      locations: [],
      savedLocations: [],
      clickedOnce: false,
      currentCard: 1,
      showDialog: false,
      canAdvance: false,
      projectId: "",
      currentLocation: 0,
      filesToUpload: [],
      isLoading: false,
      isLocationSaving: false,
      checkForSig: false,
      locationHasErrors: false,
      gpr_report: {
        activities: [],
        area_of_work: "",
        observations: "",
        customer_name: "",
        customer_signature: "",
        tech_name: "",
        tech_signature: "",
      },
      selectedItem: null,
      activities: [],
      imperialActivities: [
        "Delivered SafeCore Guidebook and Product Specifier Sheets to authorized representative",

        "Reviewed the SafeCore Marking & Communication System with authorized representative.",

        "Reviewed SafeCore marking method options: SafeCore stencils & ink and SafeCore Marking Tape Applications.",

        "Customer approved SafeCore marking methods.  Refer to the following per location summary for details.",

        "Completed the JSA (Job Safety Analysis) prior to scanning.",

        "Invited Authorized Representative to the SafeCore Project.",

        "Assisted in installing the SafeCore Application on the client’s mobile device. Saved to Home Screen.",

        "Acquired facility engineers / owners’ representatives contact information and added them as project members.",

        "Reviewed alternate marking options: Crayon, grease pencil, paint, permanent markers, painters’ tape, soapstone & concrete etching devices.",

        "Reviewed advantages & limitations of GPR.",

        "Determined and marked the outer limits of each ATS (Authorize to Scan) survey area with an authorized representative prior to scanning.",

        'Reviewed optional embedded target marking widths of 1”, 1.5" & 2" for suspended slabs, walls and beams. Refer to the following per location summary for details.',

        'Reviewed optional tolerance zone setback marking widths of 4”, 4.5" & 5" for suspended slabs, walls and beams. Refer to the following per location summary for details.',

        'Reviewed standard target marking width of 3" for all slab on grade sawcutting applications.  Refer to the following per location summary for details.',

        'Reviewed optional tolerance zone setback marking widths of 12" (6" each way from center of embedment), 18" (9" each way from center of embedment) & 24"(12" each way from center of embedment) for all slab on grade sawcutting applications. Refer to the following per location summary for details.',

        "Reviewed the CSDA Best Practices for core drilling, sawing and chipping around marked embedments.",

        "The Customer requested that the approximate depths of embedded targets be marked on the surface.  Refer to the following per location summary for details.",

        "The Customer requested the marking of the top and bottom of the corrugated pan deck. To reduce the risk of damages, core drilling through the bottom portion of the pan deck should be avoided.  Refer to the following per location summary for details.",
      ],
      metricActivities: [
        "Delivered SafeCore Guidebook and Product Specifier Sheets to authorized representative",

        "Reviewed the SafeCore Marking & Communication System with authorized representative.",

        "Reviewed SafeCore marking method options: SafeCore stencils & ink and SafeCore Marking Tape Applications.",

        "Customer approved SafeCore marking methods.  Refer to the following per location summary for details.",

        "Completed the JSA (Job Safety Analysis) prior to scanning.",

        "Reviewed advantages & limitations of GPR.",

        "Invited Authorized Representative to the SafeCore Project.",

        "Assisted in installing the SafeCore Application on the client’s mobile device. Saved to Home Screen.",

        "Acquired facility engineers / owners’ representatives contact information and added them as project members.",

        "Reviewed alternate marking options: Crayon, grease pencil, paint, permanent markers, painters’ tape, soapstone & concrete etching devices.", 

        "Determined and marked the outer limits of each ATS (Authorize to Scan) survey area with an authorized representative prior to scanning.",

        "Reviewed with authorized representative the optional embedded target marking widths of 25mm, 38mm & 50mm: For suspended slabs, walls and beams. Refer to the following per location summary for details.",

        "For suspended slabs, walls and beams: Reviewed with authorized representative the optional tolerance zone setback marking widths of 100mm, 125mm & 150mm. Refer to the following per location summary for details.",

        "For slab on grade floor sawing: Reviewed standard target marking width of 75mm for all slab on grade sawcutting applications.  Refer to the following per location summary for details.",

        "Reviewed optional tolerance zone setback marking widths of 30cm (15cm each way from center of embedment-for 100-125mm slabs), 45cm (22.5cm each way from center of embedment for 150-200mm slabs) & 60cm (30cm each way from center of embedment for slabs in excess of 200mm) for all slab on grade sawcutting applications. Refer to the following per location summary for details.",  

        "Reviewed the CSDA Best Practices for core drilling, sawing and chipping around marked embedments.",

        "The Customer requested that the approximate depths of embedded targets be marked on the surface.  Refer to the following per location summary for details.",

        "The Customer requested the marking of the top and bottom of the corrugated pan deck. To reduce the risk of damages, core drilling through the bottom portion of the pan deck should be avoided.  Refer to the following per location summary for details.",

      ],
      summaries: [],
      summaryType : [],
      imperialSummaryType: [
        {
          category: "Standard",
          items: [
            "SafeCore GPR Tech Standard Tasks",
            "RSSI: Reviewed SafeCore Standard stencils and ink and SafeCore Standard marking tape application methods and marking options with authorized representative.  ",
            'CTHRUE.LS: Performed a IDS C - Thrue GPR Line Scan and marked targets.',
            'CTHRUE.GS: Performed a IDS C - Thrue GPR Grid Scan and marked targets.',
            'CTHRUEXS.LS: Performed a IDS C - Thrue - XS GPR Line Scan and marked targets.',
            'CTHRUEXS.GS: Performed a IDS C - Thrue - XS Grid Scan and marked targets.',
            'ATSI: Identified / Marked Perimeter of "ATS" (Authorized to Scan) location with SafeCore "ATS" “GPR SURVEY AREA” CORNER / PERIMETER stencils.',
            'ATST: Identified / Marked Perimeter of "ATS" (Authorized to Scan) location with SafeCore "ATS" white marking tape.',
            "PCQ80LS: Performed a Proceq GP8000 GPR Line Scan and marked targets. ",
            "PCQ88LS: Performed a Proceq GP8800 GPR Line Scan and marked targets. ",
            "PCQ80GS: Performed a 2'X2' Proceq GP8000 Grid Scan and marked targets ",
            "PCQ88LS: Performed a 2'X2' Proceq GP8800 Grid Scan and marked targets. ",
            "HPS10LS: Performed a Hilti PS1000 Line Scan and marked targets.",
            "HPS10GS: Performed a 2'X2' Hilti PS1000 Grid Scan and marked targets. ",
            "AQR: Applied SafeCore ATS Location specific QR code label.",
            'GT1.5: Marked GPR Targets 1.5" wide as authorized.',
            'GT2: Marked GPR Targets 2" wide as authorized. ',
            "NOGPRT: Marked No GPR Targets detected in ATS Survey area.",
            "ANCHR:  Marked GPR Target embedment to clear for anchor installation.",
          ],
          show: false,
        },
        {
          category: "Stencil",
          items: [
            "SafeCore GPR Tech Stencil Marking Options",
            "NSCZ: Marked areas inaccessible to the GPR scanner (due to wall or obstruction) with SafeCore “NO SCAN ZONE” stencils and permanent ink.",
            "TBPAN: Marked approximate location of top and bottom of corrugated pan deck with SafeCore black “TOP OF PAN DECK” and red “BOTTOM OF PAN DECK” stencils as instructed.",
            "TBT: Marked Approximate Location of Top and Bottom of Targets as directed. ",
            "GPRT: Marked GPR target embedment anomalies with SafeCore “GPR TARGET” stencils and black permanent ink.",
            "OBS: Marked GPR target embedment anomalies with SafeCore “OBSTRUCTION” stencils and black permanent ink. ",
            "COND: Marked GPR target embedment’s perceived to be a conduit with SafeCore “CONDUIT” stencils and red permanent ink. ",
            "LP: Marked Live Power target embedment as detected by the scanners Electromagnetic (EM) sensor with SafeCore “LIVE POWER” stencils and red permanent ink. ",
            "PT: Marked GPR target embedment perceived to be a PT cable with SafeCore “PT CABLE” stencils and red permanent ink.",
            "CL: Marked core locations w/ SafeCore -Center Line Core Stencils and green ink upon completion of concrete imaging as directed.",
            "NTD: Marked “NO GPR TARGETS DETECTED” stencil and green ink in areas where no targets could be detected. ",
            "ANCHR:  Marked GPR Target embedment to clear for anchor installation ",
            "CMPS: Marked GPR survey area with SafeCore Compass stencil to assist in orientation ",
            "NCL1”: Marked GPR survey area with NO CORE LAYOUT WITHIN 1” OF MARKED TARGETS ",
            "NCL1.5”: Marked GPR survey area with NO CORE LAYOUT WITHIN 1.5” OF MARKED TARGETS",
            "NCL2”: Marked GPR survey area with NO CORE LAYOUT WITHIN 2” OF MARKED TARGETS",
          ],
          show: false,
        },
        {
          category: "Depths",
          items: [
            "1”-12” Depth of Targets Stencil & Tape Marking Options",
            "MADTS1”: Marked approximate +/- depth of marked targets @ 1”",
            "MADTS2”: Marked approximate +/- depth of marked targets @ 2”",
            "MADTS3”: Marked approximate +/- depth of marked targets @ 3”",
            "MADTS4”: Marked approximate +/- depth of marked targets @ 4”",
            "MADTS5”: Marked approximate +/- depth of marked targets @ 5”",
            "MADTS6”: Marked approximate +/- depth of marked targets @ 6”",
            "MADTS7”: Marked approximate +/- depth of marked targets @ 7”",
            "MADTS8”: Marked approximate +/- depth of marked targets @ 8”",
            "MADTS9”: Marked approximate +/- depth of marked targets @ 9”",
            "MADTS10”: Marked approximate +/- depth of marked targets @10”",
            "MADTS11”: Marked approximate +/- depth of marked targets @11”",
            "MADTS12”: Marked approximate +/- depth of marked targets @12”",
          ],
          show: false,
        },
        {
          category: "Tolerance Zone",
          items: [
            "SafeCore GPR Tech Tolerance Zone Marking Options",
            "GT4.5TZ: Marked GPR Target anomalies in red with SafeCore “GPR TARGET” 4.5” wide Tolerance Zone Stencil as directed by Authorized Representative",
            "GT5TZ: Marked GPR Target anomalies in red with SafeCore “GPR TARGET” 5” wide Tolerance Zone Stencil as directed by Authorized Representative",
            "CD4.5TZ: Marked GPR Target embedment’s perceived to be a conduit in red with SafeCore “CONDUIT” 4.5” wide Tolerance Zone Stencil as directed by Authorized Representative ",
            "CD5TZ: Marked GPR Target embedment’s perceived to be a conduit in red with SafeCore “CONDUIT” 5” wide Tolerance Zone Stencil as directed by Authorized Representative ",
            "PT4.5TZ: Marked GPR Target embedment’s perceived to be a PT Cable in red with SafeCore “PT CABLE” 4.5” wide Tolerance Zone Stencil as directed by Authorized Representative ",
            "PT5TZ: Marked GPR Target embedment’s perceived to be a PT Cable in red with SafeCore “PT CABLE” 5” wide Tolerance Zone Stencil as directed by Authorized Representative",
            "LP4.5TZ: Marked GPR Targets as indicated by the scanners Electromagnetic (EM) Sensor in red with “LIVE POWER”4.5” wide Tolerance Zone Stencil as directed by Authorized Representative",
            "LP5TZ: Marked GPR Targets as indicated by the scanners Electromagnetic (EM) Sensor in red with SafeCore “LIVE POWER” 5” wide Tolerance Zone Stencil as directed by Authorized Representative",
          ],
          show: false,
        },
        {
          category: "Tape",
          items: [
            "SafeCore GPR Tech Tape Marking Options",
            'ATST: Identified / Marked Perimeter of "ATS" (Authorized to Scan) location with SafeCore "ATS" white marking tape',
            "GPRTT: Marked GPR target embedment anomalies with SafeCore 2” wide black “GPR TARGET” tape",
            "RBRT: Marked GPR target embedment perceived to be rebar through data collected from facility with SafeCore 2” wide black “REBAR” tape",
            "CONDT: Marked GPR target embedment perceived to be a conduit with SafeCore 2” wide red “CONDUIT” tape",
            "LPT: Marked live power GPR target embedment as detected by the scanners Electromagnetic (EM) sensor with SafeCore 2” wide red “LIVE POWER” tape",
            "PTT: Marked GPR target embedment perceived to be a PT Cable with 2” wide SafeCore red “PT CABLE” tape",
            "NSBT: Marked “NO SAWCUT BEYOND THIS LINE” tolerance zone with SafeCore 2” wide sawcut tolerance zone tape.",
            "NCLBT: Marked “NO CORE LAYOUT” tolerance zone with SafeCore 2” wide core drill layout tolerance zone tape.",
            "TPDT: Marked “TOP OF PAN DECK” with 2” wide SafeCore black tape",
            "BPDT:  Marked “BOTTOM OF PAN DECK” with 2” wide SafeCore red tape.",
            "NTDS:  Applied green “NO GPR TARGETS DETECTED” sticker in areas where no targets could be detected.",
            "BPTA: Applied Blue Painters Tape prior to sensitive surfaces prior to SafeCore tape applications. ",
          ],
          show: false,
        },
        {
          category: "Slab on Grade",
          items: [
            "GPR Tech Slab-on-Grade Stencil Marking Options",
            'SOGATS: Identified / Marked Perimeter of "ATS" (Authorized to Scan) slab on grade locations with SafeCore "ATS" “GPR SURVEY AREA” slab on grade corner and perimeter stencils & permanent ink',
            "SOGWM: Marked “WIRE MESH LOCATED THROUGHOUT” slab-on-grade where applicable",
            'SOG3: Marked slab on grade GPR Targets 3" wide as authorized ',
            'SOGC12: Marked slab on grade target embedment’s perceived to be a conduit with SafeCore 3" wide “CONDUIT” / 12" wide "No Sawcut beyond this line" Tolerance Zone Stencil in red as directed by authorized representative',
            'SOGC18: Marked slab on grade target embedment’s perceived to be a conduit with SafeCore 3" wide “CONDUIT” / 18" wide "NO SAWCUT BEYOND THIS LINE" Tolerance Zone Stencil in red as directed by authorized representative',
            'SOGC24: Marked Slab on Grade Target embedment’s perceived to be a conduit with SafeCore 3" wide “CONDUIT” / 24" wide " NO SAWCUT BEYOND THIS LINE Tolerance Zone Stencil in red as directed by authorized representative',
            'SOGGT12: Marked Slab on Grade Target anomalies 3" wide with GPR TARGET / 12" wide " NO SAWCUT BEYOND THIS LINE " Tolerance Zone Stencil in red as directed by authorized representative',
            'SOGGT18: Marked Slab on Grade Target anomalies 3" wide with GPR TARGET / 18" wide " NO SAWCUT BEYOND THIS LINE " Tolerance Zone Stencil in red as directed by authorized representative',
            'SOGGT24: Marked Slab on Grade Targets anomalies 3" wide with GPR TARGET / 24" wide " NO SAWCUT BEYOND THIS LINE” Tolerance Zone Stencil in red as directed by authorized representative',
            'SOGLP12: Marked “Live Power” Slab on Grade Targets 3" wide with LIVE POWER / 12" wide " NO SAWCUT BEYOND THIS LINE " Tolerance Zone Stencil in red as directed by authorized representative',
            'SOGLP18: Marked “Live Power” Slab on Grade Targets 3" wide with LIVE POWER / 18" wide " NO SAWCUT BEYOND THIS LINE " Tolerance Zone Stencil in red as directed by authorized representative',
            'SOGLP24: Marked “Live Power” Slab on Grade Targets 3" wide with LIVE POWER / 24" wide " NO SAWCUT BEYOND THIS LINE " Tolerance Zone Stencil in red as directed by authorized representative',
          ],
          show: false,
        },
        {
          category: "Options",
          items: [
            "SafeCore GPR Tech Optional Marking Methods",
            "GTPM: Marked GPR targets in permanent marker",
            "GTSP: Marked GPR targets with spray paint",
            "GTCP: Marked GPR targets with crayon / pencil ",
            "GTCED: Marked targets with concrete etching device",
            "GTRBI: Marked GPR Targets with SafeCore Rulers and Black Permanent Ink / Markers",
            "GTRRI: Marked GPR Targets with SafeCore Rulers and Red Permanent Ink / Markers",
            "CPX10: Marked Center Line of Drill Bit Entry Position & Exit Position w/Hilti PX-10 Trans pointer as authorized.",
            "HPS10GS44: Performed a 4’x4' Hilti PS1000 Grid Scan and marked targets.",
            "GSSIGS: Performed GSSI Grid Scan and market targets",
            "GSSILS: Performed a GSSI Line Scan and marked targets",
            "CONQGS: Performed Conquest Grid Scan and marked targets",
            "CONQLS: Performed a Conquest Line Scan and marked targets",
            "MALAGS: Performed Mala Grid Scan and marked targets",
            "MALALS: Performed a Mala Line Scan and marked targets",
          ],
          show: false,
        },
        // {
        //   category: "SafeCore X-Ray Tech Marking Options",
        //   items: [
        //     'XRAYP: Identified / Marked Perimeter of "ATS" (Authorized to Scan) location with 14"x17" SafeCore -X-Ray Stencil',
        //     "PCOBXR: Performed Cobalt Source X-Ray / marked perimeter and targets",
        //     "PIRIDXR: Performed Iridium Source X-Ray / marked perimeter and targets",
        //     "RBXR: Marked Reinforcing bar in black w/ REBAR X-Ray stencil upon completion of X-Ray",
        //     "CDXR: Marked Conduit in red w/ LIVE POWER X-Ray stencil upon completion of X-Ray",
        //     "PTXR: Marked PT Cable in red w/ PT CABLE X-Ray stencil upon completion of X Ray ",
        //   ],
        // },
      ],
      metricSummaryType: [
        {
          category: "Standard",
          items: [
            "SafeCore GPR Tech Metric Standard Tasks",
            "RSSI: Reviewed SafeCore Standard stencils and ink and SafeCore Standard marking tape application methods and marking options with authorized representative.  ",
            'CTHRUE.LS: Performed a IDS C - Thrue GPR Line Scan and marked targets.',
            'CTHRUE.GS: Performed a IDS C - Thrue GPR Grid Scan and marked targets.',
            'CTHRUEXS.LS: Performed a IDS C - Thrue - XS GPR Line Scan and marked targets.',
            'CTHRUEXS.GS: Performed a IDS C - Thrue - XS Grid Scan and marked targets.',
            'ATSI: Identified / Marked Perimeter of "ATS" (Authorized to Scan) location with SafeCore "ATS" “GPR SURVEY AREA” CORNER / PERIMETER stencils.',
            'ATST: Identified / Marked Perimeter of "ATS" (Authorized to Scan) location with SafeCore "ATS" white marking tape.',
            "IDSCTLS: Performed a IDS – C-thru GPR Line Scan and marked targets. ",
            "IDSCTGS: Performed a IDS – C-thru GPR Grid Scan and marked targets. ",
            "PCQ80LS: Performed a Proceq GP8000 GPR Line Scan and marked targets.  ",
            "PCQ88LS: Performed a Proceq GP8800 GPR Line Scan and marked targets. ",
            "HPS10LS: Performed a Hilti PS1000 Line Scan and marked targets.",
            "HPS10GS: Performed a 2'X2' Hilti PS1000 Grid Scan and marked targets. ",
            "AQR: Applied SafeCore ATS Location Specific Barcode label.",
            'GT25: Marked GPR Targets 25mm wide as authorized.',
            'GT38: Marked GPR Targets 38mm wide as authorized. ',
            'GT50: Marked GPR Targets 50mm wide as authorized. ',
            "NOGPRT: Marked No GPR Targets detected in ATS Survey area.",
            "ANCHR:  Marked GPR Target embedment to clear for anchor installation.",
            'BPTA: Applied Blue Painters Tape prior to sensitive surfaces prior to SafeCore stencil applications.'
          ],
          show: false,
        },
        {
          category: "Stencil",
          items: [
            "SafeCore GPR Tech Stencil Marking Options",
            "NSCZ50: Marked areas inaccessible to the GPR scanner (due to wall or obstruction) with SafeCore 50mm “NO SCAN ZONE” stencils and permanent ink.",
            'NSCZ100: Marked areas inaccessible to the GPR scanner (due to wall or obstruction) with SafeCore 100mm “NO SCAN ZONE” stencils and permanent ink.',
            "TBPAN: Marked approximate location of top and bottom of corrugated pan deck with SafeCore black “TOP OF PAN DECK” and red “BOTTOM OF PAN DECK” stencils as instructed.",
            "TBT: Marked Approximate Location of Top and Bottom of Targets as directed. ",
            "GPRT: Marked GPR target embedment anomalies with SafeCore “GPR TARGET” stencils and black permanent ink.",
            "OBS: Marked GPR target embedment anomalies with SafeCore “OBSTRUCTION” stencils and black permanent ink. ",
            "COND: Marked GPR target embedment’s perceived to be a conduit with SafeCore “CONDUIT” stencils and red permanent ink. ",
            "LP: Marked Live Power target embedment as detected by the scanners Electromagnetic (EM) sensor with SafeCore “LIVE POWER” stencils and red permanent ink. ",
            "PT: Marked GPR target embedment perceived to be a PT cable with SafeCore “PT CABLE” stencils and red permanent ink.",
            "CL: Marked core locations w/ SafeCore -Center Line Core Stencils and green ink upon completion of concrete imaging as directed.",
            "NTD: Marked “NO GPR TARGETS DETECTED” stencil and green ink in areas where no targets could be detected. ",
            "NTDBMT: Marked “NO GPR TARGETS DETECTED BENEATH METAL TRACK” stencil and green ink in areas where no targets could be detected. ",
            "CTNTDBT: Marked “CAUTION! GPR TARGETS DETECTED BENEATH METAL TRACK” stencil and red ink where targets were detected beneath metal track. ",
            "ANCHR:  Marked GPR Target embedment to clear for anchor installation ",
            "CMPS: Marked GPR survey area with SafeCore Compass stencil to assist in orientation ",
            "NCL38: Marked GPR survey area with NO CORE LAYOUT WITHIN 25mm OF MARKED TARGETS ",
            "NCL38: Marked GPR survey area with NO CORE LAYOUT WITHIN 38mm OF MARKED TARGETS ",
            "NCL2”: Marked GPR survey area with NO CORE LAYOUT WITHIN 50mm OF MARKED TARGETS",
            "EMS: Marked “E-M SENSOR DETECTTED LIVE POWER IN GPR SURVEY AREA” stencil and red ink."
          ],
          show: false,
        },
        {
          category: "Depths",
          items: [
            "25mm-300mm Depth of Targets Stencil & Tape Marking Options",
            "MADTS25: Marked approximate +/- depth of marked targets @ 25mm",
            "MADTS50: Marked approximate +/- depth of marked targets @ 50mm",
            "MADTS75: Marked approximate +/- depth of marked targets @ 75mm",
            "MADTS100: Marked approximate +/- depth of marked targets @ 100mm",
            "MADTS125: Marked approximate +/- depth of marked targets @ 125mm",
            "MADTS150: Marked approximate +/- depth of marked targets @ 150mm",
            "MADTS175: Marked approximate +/- depth of marked targets @ 175mm",
            "MADTS200: Marked approximate +/- depth of marked targets @ 200mm",
            "MADTS225: Marked approximate +/- depth of marked targets @ 225mm",
            "MADTS250: Marked approximate +/- depth of marked targets @ 250mm",
            "MADTS275: Marked approximate +/- depth of marked targets @ 275mm",
            "MADTS300: Marked approximate +/- depth of marked targets @ 300mm"
          ],
          show: false,
        },
        {
          category: "Tolerance Zone",
          items: [
            "SafeCore GPR Tech Metric Tolerance Zone Marking Options",
            "GT100TZ: Marked GPR Target anomalies in red with SafeCore “GPR TARGET” 100” wide Tolerance Zone Stencil as directed by Authorized Representative", 
            "GT125TZ: Marked GPR Target anomalies in red with SafeCore “GPR TARGET” 125mm wide Tolerance Zone Stencil as directed by Authorized Representative", 
            "GT150TZ: Marked GPR Target anomalies in red with SafeCore “GPR TARGET” 150mm wide Tolerance Zone Stencil as directed by Authorized Representative", 
            "CD100TZ: Marked GPR Target embedment’s perceived to be a conduit in red with SafeCore “CONDUIT” 100mm wide Tolerance Zone Stencil as directed by Authorized Representative", 
            "CD125TZ: Marked GPR Target embedment’s perceived to be a conduit in red with SafeCore “CONDUIT” 100mm wide Tolerance Zone Stencil as directed by Authorized Representative", 
            "CD150TZ: Marked GPR Target embedment’s perceived to be a conduit in red with SafeCore “CONDUIT” 150mm wide Tolerance Zone Stencil as directed by Authorized Representative", 
            "PT100TZ: Marked GPR Target embedment’s perceived to be a PT Cable in red with SafeCore “PT CABLE” 100mm wide Tolerance Zone Stencil as directed by Authorized Representative", 
            "PT125TZ: Marked GPR Target embedment’s perceived to be a PT Cable in red with SafeCore “PT CABLE” 125mm wide Tolerance Zone Stencil as directed by Authorized Representative", 
            "PT150TZ: Marked GPR Target embedment’s perceived to be a PT Cable in red with SafeCore “PT CABLE” 150mm wide Tolerance Zone Stencil as directed by Authorized Representative", 
            "LP100TZ: Marked GPR Targets as indicated by the scanners Electromagnetic (EM) Sensor in red with “LIVE POWER” 100mm wide Tolerance Zone Stencil as directed by Authorized Representative", 
            "LP125TZ: Marked GPR Targets as indicated by the scanners Electromagnetic (EM) Sensor in red with “LIVE POWER” 125mm wide Tolerance Zone Stencil as directed by Authorized Representative", 
            "LP150TZ: Marked GPR Targets as indicated by the scanners Electromagnetic (EM) Sensor in red with “LIVE POWER” 150mm wide Tolerance Zone Stencil as directed by Authorized Representative", 

          ],
          show: false,
        },
        {
          category: "Tape",
          items: [
            "SafeCore GPR Tech Metric Tape Marking Options",
            'ATST: Identified / Marked Perimeter of "ATS" (Authorized to Scan) location with SafeCore "ATS" white marking tape',
            "GPRTT: Marked GPR target embedment anomalies with SafeCore 2” wide black “GPR TARGET” tape",
            "RBRT: Marked GPR target embedment perceived to be rebar through data collected from facility with SafeCore 2” wide black “REBAR” tape",
            "CONDT: Marked GPR target embedment perceived to be a conduit with SafeCore 50mm wide red “CONDUIT” tape ",
            "LPT: Marked live power GPR target embedment as detected by the scanners Electromagnetic (EM) sensor with SafeCore 50mm wide red “LIVE POWER” tape",
            "PTT: Marked GPR target embedment perceived to be a PT Cable with 50mm wide SafeCore red “PT CABLE” tape",
            "NSBT: Marked “NO SAWCUT BEYOND THIS LINE” tolerance zone with SafeCore 50mm wide sawcut tolerance zone tape.",
            "NCLBT: Marked “NO CORE LAYOUT” tolerance zone with SafeCore 50mm wide core drill layout tolerance zone tape.",
            "TPDT: Marked “TOP OF PAN DECK” with 75mm wide SafeCore black tape",
            "BPDT:  Marked “BOTTOM OF PAN DECK” with 75mm wide SafeCore red tape.",
            "NTDS:  Applied green “NO GPR TARGETS DETECTED” sticker in areas where no targets could be detected.",
            "BPTA: Applied Blue Painters Tape prior to sensitive surfaces prior to SafeCore tape applications."
          ],
          show: false,
        },
        {
          category: "Slab on Grade",
          items: [
            "GPR Tech Slab-on-Grade Stencil Marking Options",
            "SOGATS: Identified / Marked Perimeter of “ATS“ (Authorized to Scan) slab on grade locations with SafeCore “ATS“ “GPR SURVEY AREA” slab on grade corner and perimeter stencils & permanent ink",  
            "SOGWM: Marked “GPR DETECTED 200MM X 200MM WIRE MESH THROUGHOUT” slab-on-grade where applicable",
            "SOG3: Marked slab on grade GPR Targets 150mm wide as authorized", 
            "SOGC12: Marked slab on grade target embedment’s perceived to be a conduit with SafeCore 150mm wide “CONDUIT” / 30cm wide “No Sawcut beyond this line“ Tolerance Zone Stencil in red as directed by authorized representative",
            "SOGC18: Marked slab on grade target embedment’s perceived to be a conduit with SafeCore 150mm wide “CONDUIT” / 45cm wide “NO SAWCUT BEYOND THIS LINE“ Tolerance Zone Stencil in red as directed by authorized representative",
            "SOGC24: Marked Slab on Grade Target embedment’s perceived to be a conduit with SafeCore150mm wide “CONDUIT” / 60cm wide “NO SAWCUT BEYOND THIS LINE Tolerance Zone Stencil in red as directed by authorized representative",
            "SOGGT12: Marked Slab on Grade Target anomalies 150mm wide with GPR TARGET / 30cm wide “NO SAWCUT BEYOND THIS LINE“ Tolerance Zone Stencil in red as directed by authorized representative",
            "SOGGT18: Marked Slab on Grade Target anomalies 150mm wide with GPR TARGET / 45cm wide “NO SAWCUT BEYOND THIS LINE“ Tolerance Zone Stencil in red as directed by authorized representative",
            "SOGGT24: Marked Slab on Grade Targets anomalies 150mm wide with GPR TARGET / 60cm wide “NO SAWCUT BEYOND THIS LINE” Tolerance Zone Stencil in red as directed by authorized representative",
            "SOGLP12: Marked “Live Power” Slab on Grade Targets 150mm wide with LIVE POWER / 30cm wide “NO SAWCUT BEYOND THIS LINE“ Tolerance Zone Stencil in red as directed by authorized representative",
            "SOGLP18: Marked “Live Power” Slab on Grade Targets 150mm wide with LIVE POWER / 45cm wide “NO SAWCUT BEYOND THIS LINE “ Tolerance Zone Stencil in red as directed by authorized representative",
            "SOGLP24: Marked “Live Power” Slab on Grade Targets 150mm wide with LIVE POWER / 60cm wide “NO SAWCUT BEYOND THIS LINE“ Tolerance Zone Stencil in red as directed by authorized representative",
            "WLINE: Marked “Water Line” above 150mm GPR Target",
            "SWDLINE: Marked “Sewer-Drain Line” above 150mm GPR Target",
          ],
          show: false,
        },
        {
          category: "Options",
          items: [
            "SafeCore GPR Tech Optional Marking Methods",
            "GTPM: Marked GPR targets in permanent marker",
            "GTSP: Marked GPR targets with spray paint",
            "GTCP: Marked GPR targets with crayon / pencil ",
            "GTCED: Marked targets with concrete etching device",
            "GTRBI: Marked GPR Targets with SafeCore Rulers and Black Permanent Ink / Markers",
            "GTRRI: Marked GPR Targets with SafeCore Rulers and Red Permanent Ink / Markers",
            "CPX10: Marked Center Line of Drill Bit Entry Position & Exit Position w/Hilti PX-10 Trans pointer as authorized.",
            "HPS10GS44: Performed a 4’x4' Hilti PS1000 Grid Scan and marked targets.",
            "GSSIGS: Performed GSSI Grid Scan and market targets",
            "GSSILS: Performed a GSSI Line Scan and marked targets",
            "CONQGS: Performed Conquest Grid Scan and marked targets",
            "CONQLS: Performed a Conquest Line Scan and marked targets",
            "MALAGS: Performed Mala Grid Scan and marked targets",
            "MALALS: Performed a Mala Line Scan and marked targets",
          ],
          show: false,
        },
        // {
        //   category: "SafeCore X-Ray Tech Marking Options",
        //   items: [
        //     'XRAYP: Identified / Marked Perimeter of "ATS" (Authorized to Scan) location with 14"x17" SafeCore -X-Ray Stencil',
        //     "PCOBXR: Performed Cobalt Source X-Ray / marked perimeter and targets",
        //     "PIRIDXR: Performed Iridium Source X-Ray / marked perimeter and targets",
        //     "RBXR: Marked Reinforcing bar in black w/ REBAR X-Ray stencil upon completion of X-Ray",
        //     "CDXR: Marked Conduit in red w/ LIVE POWER X-Ray stencil upon completion of X-Ray",
        //     "PTXR: Marked PT Cable in red w/ PT CABLE X-Ray stencil upon completion of X Ray ",
        //   ],
        // },
      ],
      projectData: [
        {
          field: "ats_number",
          field_name: "ATS Number",
          lg: false,
          data: "",
          line: true,
        },
        {
          field: "prepared_for_name",
          div: "Prepared For",
          sub: "Name",
          lg: true,
          data: "",
          line: false,
        },
        {
          field: "prepared_for_address",
          lg: true,
          sub: "Address",
          data: "",
          line: true,
        },
        {
          field: "job_name",
          lg: false,
          field_name: "Job Name",
          data: "",
          line: true,
        },
        {
          field: "job_site",
          lg: false,
          field_name: "Job Site Address",
          data: "",
          line: true,
        },
        {
          field: "project_manager_name",
          div: "Project Manager",
          lg: true,
          sub: "Name",
          data: "",
          line: false,
        },
        {
          field: "project_manager_phone",
          lg: true,
          sub: "Phone",
          data: "",
          line: false,
        },
        {
          field: "project_manager_email",
          lg: true,
          sub: "Email",
          data: "",
          line: true,
        },
        {
          field: "site_contact_name",
          div: "Site Contact",
          lg: true,
          sub: "Name",
          data: "",
          line: false,
        },
        {
          field: "site_contact_phone",
          lg: true,
          sub: "Phone",
          data: "",
          line: false,
        },
        {
          field: "site_contact_email",
          lg: true,
          sub: "Email",
          data: "",
          line: true,
        },
        {
          field: "po_number",
          lg: false,
          field_name: "PO Number",
          data: "",
          line: true,
        },
        {
          field: "prepared_by",
          lg: false,
          field_name: "Prepared By: Name",
          data: "",
          line: true,
        },
      ],
      showAllTasks: true,
      gpr_task_type: 'imperial',

    };
  },
  created() {
    this.gpr_task_type = this.$store.state.user.gpr_task_type;
    if(this.gpr_task_type == 'imperial'){
      this.activities = this.imperialActivities
      // this.gpr_report.activities = this.imperialActivities
      this.summaryType = this.imperialSummaryType
    }else{
      this.activities = this.metricActivities
      // this.gpr_report.activities = this.metricActivities
      this.summaryType = this.metricSummaryType
    }
    this.projectId = this.$route.params.id;
    if (this.projectId == undefined) {
      this.$router.push("projectportal");
    } else {
      api.getProjectForGPR(this.projectId).then((response) => {
        this.projectData.forEach((d) => {
          var count = (d.field.match(/_/g) || []).length;
          if (count == 1) {
            d.data = idx(response, (_) => _.data[d.field]);
          } else if (count == 2) {
            var last_under = d.field.lastIndexOf("_");
            var header = d.field.slice(0, last_under);
            var currentField = d.field.slice(last_under + 1);
            d.data = idx(response, (_) => _.data[header][currentField]);
          }
        });
        if (response.data.locations && response.data.locations.length > 0) {
          this.locations = idx(response, (_) => _.data.locations);
          this.locations.forEach((l) => {
            l.newL = false;
            l.summaries = l.survey_summary.split(";");
          });
          this.savedLocations = this.locations;
        } else {
          this.locations = [];
          this.addBlankLocation();
        }
        //filling in last card fields
        this.gpr_report.customer_name = idx(
          response,
          (_) => _.data.prepared_for.name
        );
        this.gpr_report.tech_name = idx(response, (_) => _.data.prepared_by);

        this.request.signed_company_name = idx(response, _ => _.data.prepared_for.name);
        this.request.signed_user_name = idx(response, _ => _.data.site_contact.name);
        this.request.customer_signature = idx(response, _ => _.data.customer_signature);
      });
    }
  },
  methods: {
    deleteLocation2(location_id) {
      // Use splice to remove the location at the given index
      if (this.locations.length == 1) {
        return this.notifyVue("Please add at least one location", "error");
      }
      if (location_id == undefined) {
        this.locations.pop();
      } else {
        this.locations = this.locations.filter(location => location.id !== location_id);
      }
      this.currentLocation = this.locations.length - 1;
      if (this.currentLocation < 0) {
        this.currentLocation = 0;
      }
    },
    deleteLocation(location_id) {
      // Use splice to remove the location at the given index
      var data = {
        location_id: location_id,
        project_id: this.projectId
      }
      api.deleteLocation(data).then((response) => {
        this.savedLocations = this.savedLocations.filter(location => location.id !== location_id);
      })
    },
    clearSummary(id) {
      this.$nextTick(() => {
        const selectBox = this.$refs.selectDropdown[0].$el;
        selectBox.querySelector(".md-select-value").click();
      });

      // const location = this.locations.find(function (loc) {
      //   return loc.id === id;
      // });

      // if (location) {
      //   location.summaries = [];
      // }
    },
    saveBarcodeNumber(data) {
      this.showDialog = !this.showDialog;
      this.locations[data.index].barcode_number = data.code;
    },
    showBarcodeScanner() {
      this.showDialog = !this.showDialog;
    },
    openPic(url) {
      window.open(url, "_blank");
    },
    notifyVue(message, color) {
      this.$notify({
        timeout: 2500,
        message: message,
        horizontalAlign: "left",
        verticalAlign: "top",
        type: color,
      });
    },
    nextCard(num) {
      let newCard = num + 1;
      this.currentCard = newCard;
      window.scrollTo(0, 0);
    },
    prevCard(num) {
      let newCard = num - 1;
      this.currentCard = newCard;
      window.scrollTo(0, 0);
    },
    goSignature(num){
      this.currentCard = num;
      window.scrollTo(0, 0);
    },
    findField(name) {
      var obj = this.projectData.find((el) => el.field == name);
      if (obj.data == null || obj.data == "") {
        return "Not Available";
      } else {
        return obj.data;
      }
    },
    getFiles(filesList, index) {
            var formData = new FormData();
      var locationId = this.locations[index].id;
      /** If the location exists, use the existing 'addFiletoLocation'
       *  apply the return 'data' into 'this.locations' */
      if (locationId) {
                const file = filesList[0]
        // filesList.forEach((file) => {
          formData.append("file[]", file);
        // });
        api.addFileToLocation(locationId, formData).then(({ data }) => {
          const newLocations = this.locations.map((l) => ({ ...l }));
          newLocations[index].files = data;
          this.locations = newLocations;
        });
      } else {
        var ok = [];
        this.setFilesToUpload(filesList);
        this.locations[index].imgPlaceholder = "";
        for (let i = 0; i < filesList.length; i++) {
          let fileUrl = URL.createObjectURL(filesList[i]);
          let newFile = {
            url: fileUrl,
            filename: filesList[i].name,
          };
          ok.push(newFile);
        }
        const newLocations = this.locations.map((l) => ({ ...l }));
        newLocations[index].files = [...newLocations[index].files, ...ok];
        this.locations = newLocations;
        this.locations[index].imgPlaceholder = "";
      }
    },
    setFilesToUpload(filesList) {
      this.filesToUpload = [...this.filesToUpload, ...filesList];
    },
    removeItem(item, index, type) {
      if (type === "summary") {
        var sIndex = this.locations[index].summaries.findIndex(
          (i) => i == item
        );
        this.locations[index].summaries.splice(sIndex, 1);
      } else {
        var aIndex = this.gpr_report.activities.findIndex((i) => i == item);
        this.gpr_report.activities.splice(aIndex, 1);
      }
    },
    removeFile(item, index) {
      const newLocations = this.locations.map((l) => ({ ...l }));
      newLocations[index].files = newLocations[index].files.filter(
        (f) => f.url !== item.url
      );
      this.locations = newLocations;
      if (this.filesToUpload.length) {
        this.filesToUpload = this.filesToUpload.filter(
          (f) => f.name !== item.filename
        );
      }
    },
    updateLData(index) {
      this.locations[index].ats_location_number = index + 1;
      if (this.locations[index].summaries){
        this.locations[index].survey_summary = this.locations[index].summaries.join("; ");
      }
    },
    updateLocation(location) {
      this.filesToUpload = [];
      var a = api
        .updateLocation({ location: location })
        .then((response) => {
          this.notifyVue("Location has been saved", "success");
          // if (move == 'save'){
          //   console.log('ready to advance')
          //   this.canAdvance = true;
          // }
          return true;
        })
        .catch((err) => {
          console.log(err);
          this.locationHasErrors = true;
          // this.locationErrors = err;
          return false;
        });
      return a;
    },
    createBELocation(location, move) {
      var formData = new FormData();
      formData.append("location", JSON.stringify(location));
      if (this.filesToUpload.length) {
        for (let i = 0; i < this.filesToUpload.length; i++) {
          formData.append("files[]", this.filesToUpload[i]);
        }
      }
      this.filesToUpload = [];
      var b = api
        .createGPRLocation(formData)
        .then((response) => {
          this.notifyVue("Location has been created", "success");
          // var location = response.data.location;
          console.log(this.locations);
          const newLocations = JSON.parse(JSON.stringify(this.locations));
          newLocations[newLocations.length - 1].id = response.data.location.id;
          this.locations = newLocations;
          location.id = response.data.location.id;
          this.savedLocations.push(location);
          return true;
        })
        .catch((err) => {
          console.log('API Error', err);
          this.locationHasErrors = true;
          this.isLocationSaving = false;
          return false;
        });
      return b;
    },
    addBlankLocation() {
      this.locations.push({
        description: "",
        customer_signature: "",
        name: "",
        // images: [],
        files: [],
        imgPlaceholder: [],
        latitude: "",
        longitude: "",
        project_id: this.projectId,
        summary_notes: "",
        survey_summary: [],
        summaries: [],
        barcode_number: "",
        newL: true,
        status: "draft",
      });

      console.log('locations-------->', this.locations)
    },
    async changeLocation(index, move) {
      let location = this.locations[index];
      this.isLocationSaving = true;
      this.updateLData(index);
      try {   
        if (this.locations[index].newL) {
          var passed = await this.createBELocation(this.locations[index], move);
          this.locations[index].newL = false;
        } else {
          var passed = await this.updateLocation(this.locations[index], move);
        }
      } catch (error) {
        console.log('error location error', error);
      }
      if (passed) {
        switch (move) {
          case "next":
            this.currentLocation = index + 1;
            console.log("done saving????");
            this.isLocationSaving = false;
            this.canAdvance = false;
            break;
          case "prev":
            this.currentLocation = index - 1;
            this.isLocationSaving = false;
            this.canAdvance = false;
            break;
          case "save":
            this.canAdvance = true;
            this.isLocationSaving = false;
            this.locations[index].status = "saved";
            break;
          case "add":
            this.showAllTasks = true;
            this.addBlankLocation();
            this.summaryType.forEach((type) => {
              type.show = false;
            });
            this.currentLocation = index + 1;
            this.isLocationSaving = false;
            this.canAdvance = true;
            this.isLocationSaving = false;
            this.locations[index].status = "saved";
            break;
        }
      }
    },
    submitSign() {
      this.clickedOnce = true;
      this.isLoading = true;
      api
        .submitSign({ customer_signature: this.request.customer_signature, project_id: this.projectId })
        .then((response) => {
          this.notifyVue("Signature has been added", "success");
          this.$router.push(`/projects/${this.projectId}`);
        });
    },
    submitGPR() {
      this.clickedOnce = true;
      this.isLoading = true;
      api
        .submitGPR({ gpr_report: this.gpr_report, project_id: this.projectId })
        .then((response) => {
          this.notifyVue("GPR Report has been created", "success");
          this.$router.push(`/projects/${this.projectId}`);
        });
    },
    formatAddress(str) {
      var ad = this.findField(str);
      for (const comp in ad) {
        if (ad[comp] == null) {
          ad[comp] = "";
        }
      }
      if (ad == null || ad == {} || ad == "" || ad == "Not Available") {
        return "Address Not Available";
      } else {
        var full_ad =
          ad.street_address +
          " " +
          ad.address_line_2 +
          ", " +
          ad.city +
          ", " +
          ad.state +
          " " +
          ad.zip_code;
        return full_ad;
      }
    },
    saveSig(data) {
      console.log('data', data)
      this.request.customer_signature = data;
    },
    saveSig2(data) {
      this.gpr_report.customer_signature = data;
      this.checkForSig = true;
    },
    showTaskAll() {
      this.summaryType.forEach((type) => {
        type.show = true;
      });
      const showSelect = this.$refs.selectDropdown[0].showSelect;
      if (!showSelect) {
        this.$refs.selectDropdown[0].showSelect = true;
      }
      this.showAllTasks = true;
    },
    showTask(index) {
      this.showAllTasks = false;
      this.summaryType.forEach((type) => {
        type.show = false;
      });
      this.summaryType[index].show = !this.summaryType[index].show;
      const showSelect = this.$refs.selectDropdown[0].showSelect;
      if (!showSelect) {
        this.$refs.selectDropdown[0].showSelect = true;
      }
     
    },
    getCategoryLabel(item) {
      // Find the category based on the selected item
      const category = this.summaryType.find((type) =>
        type.items.includes(item)
      );
      // Return the category label if found
      if (category) {
        return category.category;
      }
      // Return a default label if category is not found
      return "Unknown Category";
    }
  },
  filters: {
    truncate: function (text, stop) {
      return text.slice(0, stop) + (stop < text.length ? "..." : "");
    },
  },
  computed: {
    selectedItems() {
      const itemsToShow = this.summaryType
        .filter((type) => type.show) // Filter based on the `show` property
        .flatMap((type) => type.items);

      return itemsToShow;
    },
    // add computed properties for other categories as needed
  },
  watch: {
    locations: function () {
      console.log("test");
    },
  }
};
</script>
<style lang="scss">
// styles have been moved to md/gpr_report.scss
.saving-notes {
  text-align: center;
}
.helper {
  margin: 0;
}
.md-disabled span {
  color: gray;
}
.md-field label {
  color: var(
    --md-theme-default-text-primary-on-background,
    rgba(0, 0, 0, 0.7)
  ) !important;
  font-size: 14px !important;
}
.survey-des {
  padding-bottom: 20px;
  margin-top: 0px;
}
.summary-field label {
  position: relative;
  top: 0 !important;
}
.summary-field {
  flex-direction: column;
}
.summary-field .md-select {
  flex-basis: 100%;
}
.d-flex {
  display: flex;
  flex-wrap: wrap;
}
.Standard .md-list-item-content {
  color: #000 !important;
}
.Stencil .md-list-item-content {
  color: green !important;
}
.Depths .md-list-item-content {
  color: blue !important;
}
.Tolerance .md-list-item-content {
  color: red !important;
}
.Tape .md-list-item-content {
  color: darkorange !important;
}
.Slab .md-list-item-content {
  color: darkcyan !important;
}
.Options .md-list-item-content {
  color: darkslateblue !important;
}
.task-lists .md-button {
  padding: 5px 10px;
}
.task-lists .md-button .md-button-content {
  font-size: 15px;
}
.select-tasks {
  max-width: 250px;
  margin-bottom: 20px;
}
label.upload-image {
  background: #c81517;
  padding: 10px 20px;
  font-size: 20px !important;
  color: #fff !important;
  top: -15px !important;
  position: absolute;
  border-radius: 3px;
}
.selected-tasks .md-icon{
  left: -40px;
  position: absolute;
  margin-top: 5px;
}
.signature-inputs{
  justify-content: space-between !important;
}
.signature-inputs .md-layout-item{
  padding-left: 0px;
}
.summaries-list .sum-list-item p{
  font-size: 15px;
}
.error-notes{
  width: 100%;
  text-align: center;
  color: red;
}
@media (max-width: 768px) {
  .task-lists .md-button {
    padding: 0px;
  }
  .task-lists .md-ripple {
    padding: 10px 15px;
  }
}
</style>
